import { render, staticRenderFns } from "./NewBranch.vue?vue&type=template&id=1204ac1f&"
import script from "./NewBranch.vue?vue&type=script&lang=js&"
export * from "./NewBranch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports